<template>
    <b-container v-if="$can('view-batch-pick') || $can('view-all')" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <h3>Batch Picks</h3>
                    </b-col>
                    <b-col class="buttons-create text-right">
                        <b-button variant="outline-primary" size="sm" @click="openModal('create-batch-pick')">New Batch</b-button>
                        <b-button variant="outline-primary" size="sm" @click="openModal('adjust-columns')"><i class="fas fa-columns"></i></b-button>
                    </b-col>
                </b-row>
                <hr>
            </b-container>
        </b-row>

        <b-row>
            <b-container fluid>
                <b-row>
                    <b-col cols="2">
                        <b-form-group>
                            <b-input-group size="sm">
                                <b-form-input v-model="tables.batchpicks.filter" type="search" id="filterInput"
                                    placeholder="Type to Search" debounce="500"></b-form-input>
                                <b-input-group-append>
                                    <b-button :disabled="!tables.batchpicks.filter"
                                        @click="tables.batchpicks.filter = ''">Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="9" />

                    <b-col cols="1">
                        <b-form-group>
                            <b-form-select v-model="tables.batchpicks.perPage" id="perPageSelect" size="sm"
                                :options="tables.batchpicks.pageOptions"></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="row-batch-pick-table">
                    <b-container fluid>
                        <b-table v-if="tables.batchpicks.ready" :key="tables.batchpicks.key" class="batch-pick-table"
                            responsive bordered striped hover no-border-collapse sticky-header="calc(100vh - 250px)"
                            head-variant="light" :items="tables.batchpicks.items" :fields="visibleFields"
                            :sort-by="tables.batchpicks.sortBy" :sort-desc="tables.batchpicks.sortDesc"
                            :per-page="tables.batchpicks.perPage" :current-page="tables.batchpicks.currentPage"
                            :filter="tables.batchpicks.filter" @filtered="onFiltered" :busy="tables.batchpicks.isBusy">

                            <template v-slot:table-busy>
                                <div class="text-center text-default my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>

                            <template v-slot:cell(created_at)="row">
                                {{ row.item.created_at | moment('MM-DD-YYYY hh:mm:ss') }}
                            </template>

                            <!-- <template v-slot:cell(items_in_batch)="row">
                                {{ row.item.batch_picks_items.length }}
                            </template> -->

                            <template v-slot:cell(created_by_id)="row">
                                    {{ row.item.user.name }}
                                </template>

                            <template v-slot:cell(actions)="row">
                                <b-container class="actions-icons" fluid>
                                    <b-row>
                                        <b-col>
                                            <b-link @click="openModal('show-batch-details', row.item)"><i
                                                    class="fas fa-edit"></i></b-link>
                                        </b-col>
                                        <!-- <b-col v-if="$can('view-all')">
                                            <b-link @click="" class="icon-danger"><i class="fas fa-trash-alt"></i></b-link>
                                        </b-col> -->
                                    </b-row>
                                </b-container>
                            </template>
                        </b-table>
                    </b-container>
                </b-row>

                <b-row>
                    <b-col cols="6">
                        {{ pageTotals }}
                    </b-col>

                    <b-col cols="6" class="my-1">
                        <b-pagination v-model="tables.batchpicks.currentPage" :total-rows="tables.batchpicks.totalRows"
                            :per-page="tables.batchpicks.perPage" align="fill" size="sm" class="my-0"></b-pagination>
                    </b-col>
                </b-row>
            </b-container>
        </b-row>

        <modal-create-batch-pick v-if="modals['create-batch-pick'].active" />

        <modal-show-batch-details v-if="modals['show-batch-details'].active" :row="modals['show-batch-details'].row"/>

        <modal-adjust-columns v-if="modals['adjust-columns'].active" :fields="modals['adjust-columns'].fields"
            @saveColSaves="saveColSaves" />
    </b-container>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import ModalAdjustColumns from '../../common/modals/AdjustColumns'
import ModalCreateBatchPick from './modals/CreateBatchPick'
import ModalShowBatchDetails from './modals/ShowBatchDetails'
import tableColumnPreferences from '../../../../mixins/tableColumnPreferences'
export default {
    name: 'BatchPick',

    mixins: [tableColumnPreferences],

    metaInfo() {
        return {
            title: 'Batch Picks',
        }
    },

    components: {
        Treeselect,
        'modal-adjust-columns': ModalAdjustColumns,
        'modal-create-batch-pick': ModalCreateBatchPick,
        'modal-show-batch-details': ModalShowBatchDetails,
    },
    data() {
        return {
            modals: {
                'adjust-columns': {
                    active: 0,
                    fields: []
                },
                'create-batch-pick': {
                    active: 0
                },
                'show-batch-details': {
                    active: 0
                },
            },
            tables: {
                batchpicks: {
                    filteredItems: [],
                    isBusy: false,
                    totalRows: 1,
                    currentPage: 1,
                    perPage: 20,
                    pageOptions: [20, 50, 100, 500],
                    sortBy: 'date_completed',
                    sortDesc: true,
                    // sortDirection: 'asc',
                    filter: null,
                    filterCat: '',
                    key: 1,
                    userFields: [],
                    fields: [
                        {
                            key: 'id',
                            label: 'ID',
                            sortable: true,
                            visible: 1
                        },
                        {
                            key: 'batch_no',
                            label: 'Batch #',
                            sortable: true,
                            visible: 1
                        },
                        {
                            key: 'created_at',
                            label: 'Date / Time',
                            sortable: true,
                            visible: 1
                        },
                        // {
                        //     key: 'items_in_batch',
                        //     label: 'Items Count',
                        //     sortable: true,
                        //     visible: 1
                        // },
                        {
                            key: 'created_by_id',
                            label: 'Created By',
                            sortable: true,
                            visible: 1
                        },
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'batchpicks-table-style-actions',
                            visible: 1
                        }
                    ],

                    items: [],
                    ready: 0
                },
            },

            exports: {
                cols: []
            }
        }
    },
    methods: {
        exportExcel(cols, keys) {
            let url = 'api/exports/generateexport'
            axios.post(url, {
                rows: this.objFilter(this.tables.batchpicks.filteredItems, keys),
                table: 'batchpicks',
                cols: cols,
                keys: keys
            },
                {
                    responseType: 'blob'
                })
                .then((res) => {
                    this.forceFileDownload(res)
                }, () => {
                    this.has_error = true
                })
        },

        forceFileDownload(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'batchpicks_Export_File_' + +new Date() + '.xlsx') //or any other extension
            document.body.appendChild(link)
            link.click()

            this.showAlertBox('success', 'File Generated', 'Sales Orders export file generated successfully!')
        },

        saveState(name) {
            let page = this.tables.batchpicks.currentPage
            let filter = this.tables.batchpicks.filter
            let perPage = this.tables.batchpicks.perPage
            this.setRememberCustomer({ name: name, page: page, filter: filter, perPage: perPage })
        },

        openModal(modalName, row, extra) {
            let prefix = 'modal-warehousing-batchpicks-'
            switch (modalName) {
                case 'show-batch-details':
                    this.modals[modalName].row = JSON.parse(JSON.stringify(row))

                    break

                case 'adjust-columns':
                    this.modals[modalName].fields = this.cloneFieldsForAdjust(this.tables.batchpicks.userFields, this.tables.batchpicks.fields)

                    break
            }

            this.modals[modalName].active = 1

            if (modalName == 'adjust-columns') {
                prefix = 'modal-common-'
            }

            this.$nextTick(() => {
                this.$bvModal.show(prefix + modalName)
            })
        },

        toggleBusy() {
            this.tables.batchpicks.isBusy = !this.tables.batchpicks.isBusy
        },

        getBatches(silent) {
            this.tables.batchpicks.ready = 0
            this.tables.batchpicks.filter = this.rememberedCustomer.filter
            this.tables.batchpicks.perPage = this.rememberedCustomer.perPage

            if (!silent) {
                this.toggleBusy()
            }

            let url = 'api/warehousing/batchpick/batches'
            axios.get(url, {})
                .then((res) => {
                    this.tables.batchpicks.items = res.data.batches
                    if (!this.tables.batchpicks.filteredItems.length) {
                        this.tables.batchpicks.filteredItems = res.data.batches
                    }
                    this.tables.batchpicks.totalRows = this.tables.batchpicks.items.length
                    this.tables.batchpicks.ready = 1

                    if (!silent) {
                        this.toggleBusy()
                    }

                    this.setLastState()
                }, () => {
                    this.has_error = true
                })
        },

        onFiltered(filteredItems) {
            this.tables.batchpicks.totalRows = filteredItems.length
            this.tables.batchpicks.currentPage = 1
            this.tables.batchpicks.filteredItems = filteredItems
        },

        setLastState() {
            this.$nextTick(() => {
                if (this.rememberedCustomer.name && this.rememberedCustomer.page) {
                    this.tables.batchpicks.currentPage = this.rememberedCustomer.page
                    this.$nextTick(() => {
                        this.$refs[this.rememberedCustomer.name].$el.scrollIntoView()
                    })
                }
            })
        },

        getColSaves() {
            let url = 'api/remembertable/getcolsaves/batchpicks'
            axios.get(url, {})
                .then((res) => {
                    if (res.data.status == 'success') {
                        if (res.data.colSaves) {
                            const merged = this.mergeColSaves(this.tables.batchpicks.fields, res.data.colSaves.column_array)
                            if (merged) {
                                this.tables.batchpicks.userFields = merged
                            }
                        }

                        this.getBatches()
                    }
                }, () => {
                    this.has_error = true
                })
        },

        saveColSaves(fields) {
            const normalized = this.normalizeColumnOrder(fields)
            this.tables.batchpicks.userFields = normalized
            let url = 'api/remembertable/savecolsaves'
            axios.post(url, {
                area: 'batchpicks',
                fields: this.formatColSavesPayload(normalized)
            })
                .then((res) => {
                    this.forceRerender()
                }, () => {
                    this.has_error = true
                })
        },

        forceRerender() {
            this.tables.batchpicks.ready = 0
            let tempFields = this.tables.batchpicks.fields
            this.tables.batchpicks.fields = []
            this.$nextTick(() => {
                this.tables.batchpicks.fields = tempFields
                this.tables.batchpicks.ready = 1
            })
        }
    },

    computed: {
        sortOptions() {
            // Create an options list from our fields
            return this.tables.batchpicks.fields
                .filter(f => f.sortable)
                .map(f => {
                    return { text: f.label, value: f.key }
                })
        },

        pageTotals() {
            let totalRows = this.tables.batchpicks.totalRows
            let currentPage = this.tables.batchpicks.currentPage
            let perPage = this.tables.batchpicks.perPage

            let from
            let to

            if (perPage > totalRows) {
                from = 1
                to = totalRows
            } else {
                to = perPage * currentPage
                from = to - perPage + 1
            }

            return 'Showing ' + from + ' to ' + to + ' of ' + this.tables.batchpicks.totalRows + ' rows'
        },

        visibleFields() {
            return this.buildVisibleFields(this.tables.batchpicks.fields, this.tables.batchpicks.userFields)
        }
    },

    mounted() {
        this.getColSaves()

        this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
            switch (modalId) {
                case 'modal-warehousing-batchpicks-create-batch-pick':
                    this.modals['create-batch-pick'].active = 0
                    this.getBatches(1)

                    break
                case 'modal-warehousing-batchpicks-show-batch-details':
                    this.modals['show-batch-details'].active = 0
                    this.modals['show-batch-details'].row = []

                    break
                case 'modal-common-adjust-columns':
                    this.modals['adjust-columns'].active = 0
                    this.modals['adjust-columns'].fields = []

                    break
            }
        })

        // pusher
        // Echo.channel('table-customer-updated')
        //     .listen('TableCustomerUpdated', (e) => {
        //         this.getbatchpicks(1)
        //     })
    }
}
</script>

<style lang="scss">
.vue-treeselect__control {
    // height: calc(1.5em + 0.5rem + 2px);
    // padding-top: 0.25rem;
    // padding-bottom: 0.25rem;
    // padding-left: 0.5rem;
    font-size: 0.875rem !important;

    .vue-treeselect__placeholder,
    .vue-treeselect__single-value {
        // line-height: 1.5
    }
}

.batch-pick-table {
    height: 75vh;
    font-size: 9pt;
}
</style>
